"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.linkPropType = exports.imagePropType = exports.descriptionPropType = exports["default"] = exports.columnPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var descriptionPropType = _propTypes["default"].shape({
  sectionHeading: _propTypes["default"].string,
  mainHeading: _propTypes["default"].string,
  paragraph: _propTypes["default"].string
});
exports.descriptionPropType = descriptionPropType;
var linkPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  label: _propTypes["default"].string,
  priority: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool,
  icon: _propTypes["default"].string
});
exports.linkPropType = linkPropType;
var columnPropType = _propTypes["default"].shape({
  image: imagePropType,
  description: descriptionPropType,
  link: linkPropType
});
exports.columnPropType = columnPropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  editorialLayout: _propTypes["default"].string,
  columns: _propTypes["default"].arrayOf(columnPropType),
  disclaimerData: _text.disclaimerDataPropTypes
});
var _default = PROP_TYPES;
exports["default"] = _default;